export const GATSBY_LOCALES = {
  ENGLISH: 'en',
  JAPANESE: 'ja',
}

export const LOCALE_CODES = {
  ENGLISH: 'en-US',
  JAPANESE: 'ja-JP',
}

export const isJapaneseLocale = () => process.env.GATSBY_LOCALE === GATSBY_LOCALES.JAPANESE
export const getLocaleCode = () => (isJapaneseLocale() ? LOCALE_CODES.JAPANESE : LOCALE_CODES.ENGLISH)
